// extracted by mini-css-extract-plugin
export const mainContent = "exhibition-module--mainContent--2fK9I";
export const cta = "exhibition-module--cta--Z5sGI";